import { useTranslation } from 'next-i18next'
import { useClearRefinements } from 'react-instantsearch'
import { Button, ButtonVariant } from 'components/common/Button'

interface ClearRefinementsProps {
  close: () => void
}

export const ClearRefinements = ({ close }: ClearRefinementsProps) => {
  const { t } = useTranslation('home')

  const { refine } = useClearRefinements(
    { includedAttributes: ['editionLiveLevel2CategoryKey'] },
    {}
  )

  const handleClear = () => {
    refine()
    close()
  }

  return (
    <Button
      fullWidth
      variant={ButtonVariant.Tertiary}
      label={t('head.clear')}
      onClick={handleClear}
    />
  )
}
